import {useApplicationContext} from "../../ApplicationContext";
import React, {useEffect, useState} from "react";
import {useLocation} from "react-router";
import SettingsPageHeader from "./Settings/SettingsPageHeader";
import {
    AppBar,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    TextField,
    Toolbar
} from "@mui/material";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import {EUserGroup, GetTermsData} from "../../apiClient/Api";
import {Close} from "@mui/icons-material";
import {MarkdownRenderer} from "../../Components/MarkdownRenderer";
import {
    BlockTypeSelect, BoldItalicUnderlineToggles,
    diffSourcePlugin,
    DiffSourceToggleWrapper,
    headingsPlugin,
    listsPlugin, ListsToggle, MDXEditor,
    toolbarPlugin,
    UndoRedo
} from "@mdxeditor/editor";


export const AdminTerms = () => {
    const context = useApplicationContext();
    const [currentTerms, setCurrentTerms] = useState<GetTermsData | undefined>(undefined);
    const [initialized, setInitialized] = useState<boolean>(false);
    const [createNewOpen, setCreateNewOpen] = useState<boolean>(false);
    const [editTile, setEditTitle] = useState<string>("");
    const [editContent, setEditContent] = useState<string>("")
    const userGroup = (context.userData?.userGroup ?? EUserGroup.CUSTOMER);
    // Die Seite hängt an zwei Routen: /terms (eigenständig) und /admin/settings/terms.
    // In der Verwaltung setzt das Settings-Layout den Titel, und der Kopf kommt aus dem
    // SettingsPageHeader statt aus einem eigenen Button-Balken.
    const inSettings = useLocation().pathname.startsWith("/admin/settings");
    useEffect(() => {
        if (!initialized) {
            setInitialized(true)
            if (!inSettings)
                context.setTitle(userGroup <= EUserGroup.ADMIN ? "Aktuelle Bedingungen" : "Admin - Bedingungen");
            context.api.terms.termsGetLatestTerms().then(data => {
                if (data.data) {
                    setCurrentTerms(data.data);
                }
            }).catch(context.apiError)
        }
    }, [initialized, currentTerms])
    const handleClose = () => {
        setEditTitle("")
        setEditContent("")
        setCreateNewOpen(false)
    }

    const openEditTerms = () => {
        setEditContent(currentTerms?.content ?? "")
        setEditTitle(currentTerms?.versionTitle ?? "")
        setCreateNewOpen(true)
    }


    const handleSave = () => {
        context.api.terms.termsReplaceTerms({
            versionTitle: editTile,
            content: editContent
        }).then(data => {
            if (data.data != undefined) {
                setCurrentTerms(data.data);
            }
        }).catch(context.apiError);
        handleClose();
    }

    return <>

        {inSettings ? (
            <SettingsPageHeader
                sectionKey="terms"
                actions={userGroup <= EUserGroup.ADMIN && (
                    <Button variant="outlined" size="small" onClick={openEditTerms}>Bedingungen ersetzen</Button>
                )}
            />
        ) : (userGroup <= EUserGroup.ADMIN &&
            <Button fullWidth size={"large"} onClick={openEditTerms}>Bedingungen ersetzen</Button>
        )}
        <Box>
            <Paper variant="outlined" style={{textAlign: "left"}} sx={{padding: 4, borderRadius: 2.5}}>
                {currentTerms != undefined && <>
                    <Typography variant={"h4"} component={"h3"} gutterBottom>{currentTerms?.versionTitle}</Typography>
                    <MarkdownRenderer>{currentTerms?.content!}</MarkdownRenderer></>}
            </Paper>
        </Box>
        {userGroup <= EUserGroup.ADMIN &&
            <Dialog fullScreen open={createNewOpen}>
                <AppBar sx={{position: 'relative'}}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <Close/>
                        </IconButton>
                        <Typography sx={{ml: 2, flex: 1}} variant="h6" component="div">
                            Neue Bedingungen hinzufügen
                        </Typography>


                    </Toolbar>
                </AppBar>
                <DialogContent>

                    <Box sx={{ marginTop: 5, marginLeft: 5, marginRight: 5 }}>
                        <TextField
                            fullWidth
                            label="Titel"
                            margin={"normal"}
                            variant="outlined"
                            value={editTile}
                            onChange={(e) => setEditTitle(e.target.value)}
                        />

                        <MDXEditor
                            markdown={editContent}
                            onChange={setEditContent}
                            plugins={[
                                listsPlugin(),
                                diffSourcePlugin(),
                                headingsPlugin(),
                                toolbarPlugin({
                                    toolbarClassName: 'my-classname',
                                    toolbarContents: () => (
                                        <>
                                            <DiffSourceToggleWrapper options={["rich-text", "source"]}>
                                                {' '}
                                                <UndoRedo />
                                                <BlockTypeSelect/>
                                                <BoldItalicUnderlineToggles />
                                                <ListsToggle />
                                            </DiffSourceToggleWrapper>
                                        </>
                                    )
                                })
                            ]}
                        />
                    </Box>
                </DialogContent>
                <DialogActions><Button fullWidth size={"large"} variant={"contained"} color={"error"}
                                       onClick={handleSave}>Bedingungen überschreiben</Button></DialogActions>
            </Dialog>
        }
    </>
}
